const isStateTouched = ({ isDirtyOptions, optionalChildren }) => {
  const touched = optionalChildren && optionalChildren.some((children) => children.touched);
  return isDirtyOptions || touched;
};

export default isStateTouched;
